var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('NotificationsBody',{attrs:{"userNotifications":_vm.notifications.notifications,"isNotifications":_vm.notifications.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }